@let modelData = model();
@let columnData = column();

@switch (columnData.key) {
  @case (getColumnKey('status')) {
    <app-refund-status [status]="modelData.status" />
  }
  @case (getColumnKey('type')) {
    <app-refund-type [type]="modelData.type" />
  }
  @case (getColumnKey('invoiceNumber')) {
    @if (isNotNil(modelData.invoiceNumber)) {
      <p-button
        (onClick)="handleDownloadInvoiceClick()"
        variant="outlined"
        tooltipPosition="bottom"
        pTooltip="Pobierz korektę faktury">
        {{ modelData.invoiceNumber }}
      </p-button>
    } @else {
      <app-no-data />
    }
  }
  @default {
    <app-table-body-no-reference-cell [columnKey]="columnData.key" />
  }
}
